<template>
    <Icon icon="question" @click="openTutorialModal" v-if="tutorialEnabled"
        :style="{ opacity: iconOpacity, width, height }"></Icon>
</template>

<script>
import state from '@/state';
import openTutorialModal from '@/widgets/Tutorial/openTutorialModal';
import Icon from '@/components/Icon.vue';

export default {
    components: {
        Icon,
    },

    props: {
        opacity: {
            type: Number,
            default: 1,
        },
        width: {
            type: String,
            default: '20px',
        },
        height: {
            type: String,
            default: '20px',
        },
    },

    methods: {
        openTutorialModal,
    },

    computed: {
        iconOpacity() {
            return this.opacity;
        },

        tutorialEnabled() {
            return state.merchantConfig.widgets?.tutorial?.enabled;
        },
    }
}
</script>